export const FONT_SIZES = {
  LARGE: 30,
  MEDIUM: 24,
  REGULAR: 18,
  SMALL: 12,
  EXTRA_SMALL: 10,
};
